export var TokenErrorStatus = /*#__PURE__*/ function(TokenErrorStatus) {
    TokenErrorStatus["Expired"] = "expired";
    TokenErrorStatus["Invalid"] = "invalid";
    TokenErrorStatus["AlreadyCompleted"] = "alreadyCompleted";
    return TokenErrorStatus;
}({});
